import { periodFormat } from 'utils/common';
import { initialTableShow } from 'utils/settings';

const SORT_FIELD_MAP = {
  roles: 'role'
};

export const PlatformTeamReq = (filters, customerId) => {
  return {
    filters: {
      customerId: customerId,
      search: filters?.search ? filters.search : '*',
      role: filters?.role[0] ? filters.role : '*',
      idp: filters?.idp[0] ? filters.idp : '*',
      'groups.name': filters?.groups[0] ? filters.groups : '*',
      lastVpnLogin: periodFormat(filters.lastVpnLogin),
      lastAppLogin: periodFormat(filters.lastAppLogin)
    },
    sort: {
      fieldName: SORT_FIELD_MAP[filters.fieldName] || filters.fieldName,
      direction: filters.direction
    }
  };
};

export const createSaveTeamList = location => {
  const query = new URLSearchParams(location.search);
  const loadList = {
    lastAppLogin:
      query.get('startApp') && query.get('startApp') !== 'null'
        ? {
            startDate: query.get('startApp'),
            endDate: query.get('endApp')
          }
        : { startDate: null, endDate: null },
    lastVpnLogin:
      query.get('startVpn') && query.get('startVpn') !== 'null'
        ? {
            startDate: query.get('startVpn'),
            endDate: query.get('endVpn')
          }
        : { startDate: null, endDate: null },
    search:
      query.get('search') && query.get('search') !== 'null'
        ? query.get('search')
        : '',
    role:
      query.get('role') && query.get('role') !== ''
        ? (query.get('role') || [])?.split(',')
        : [],
    groups:
      query.get('groups') && query.get('groups') !== ''
        ? (query.get('groups') || [])?.split(',')
        : [],
    idp:
      query.get('idp') && query.get('idp') !== ''
        ? (query.get('idp') || [])?.split(',')
        : [],
    fieldName:
      query.get('fieldName') && query.get('fieldName') !== 'null'
        ? query.get('fieldName')
        : 'firstName',
    direction:
      query.get('dir') && query.get('dir') !== 'null'
        ? Number(query.get('dir'))
        : initialTableShow.direction * -1,
    itemsPerPage:
      query.get('limit') && query.get('limit') !== 'null'
        ? Number(query.get('limit'))
        : initialTableShow.itemsPerPage,
    currentPage:
      query.get('page') && query.get('page') !== 'null'
        ? Number(query.get('page'))
        : initialTableShow.currentPage
  };
  return loadList;
};
